<script>
    import { db } from './stores.js';
    import Datepicker from './components/Datepicker.svelte';
    export let entries;
    let selectedEntry;
    let approved;
    let data;
    let timer;

    function handleClearEntry(event){
        console.log("handleClearEntry: ", event);
        selectedEntry = null;
    }

    function handleSelect(entry){
        selectedEntry = entry;
        approved = `${entry.status.approved}`;
        data = entry.status.data;
        console.log("approved: ", approved);
    }

    function handleDateTimeChange(event){
        console.log("handleDateTimeChange: ", event);
        data = event.detail.datetimeMs;
        timer.restart(data);
    }

    function handleUpdate(){
        console.log("handleUpdate")
        //update database
        $db.collection("showandtell").doc(`${selectedEntry.uid}`).set({
            status: {
                approved: approved === "true",
                data
            }
        }, {merge: true}).then(() => {
            console.log("show and tell successfully updated!");
        }).catch((error) => {
            console.error("Error updating show and tell: ", error);
        });

    }
</script>

<svelte:window on:clearEntry={handleClearEntry} />

<section>
    <div>
        {#each entries as entry}
            submitted by: <a href="https://{entry.provider}/{entry.username}" target="_blank">{entry.provider}/{entry.username}</a>
            <br/><button on:click="{() => handleSelect(entry)}">select</button>
        {/each}
    </div>
    <div>
        {#if selectedEntry}
            submitted by: <a href="https://{selectedEntry.provider}/{selectedEntry.username}" target="_blank">{selectedEntry.provider}/{selectedEntry.username}</a>
            
            <details>
                <summary>Description</summary>
                {selectedEntry.description}
            </details>
            <br/>{selectedEntry.link}
            <br/><br/>
            <select bind:value={approved} name="approved">
                <option value="true" selected={approved === true}>True</option>
                <option value="false" selected={approved === false}>False</option>
            </select>
            <br/>
            {#if approved === "true"}
                <Datepicker on:datetimechange={handleDateTimeChange}/>
                <dwane-timer bind:this={timer} timer-deadline="{data}" countdown-start="3600000"></dwane-timer>
            {:else}
                <textarea bind:value={data}></textarea>

            {/if}
            <br/><button on:click={handleUpdate}>update</button>
        {:else}
            select an entry
        {/if}
    </div>
</section>


<style>
    section {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 100%;
    }
    details {
        border: 1px solid #aaa;
        border-radius: 4px;
        padding: .5em .5em 0;
        text-align: left;
    }

    summary {
        font-weight: bold;
        margin: -.5em -.5em 0;
        padding: .5em;
    }

    details[open] {
        padding: .5em;
    }

    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: .5em;
    }

    button {
        cursor: pointer;
    }

</style>